import * as React from 'react';
import {isBrowser} from "../helpers/utils";
import type { MenuData } from "../rest.interface";
import MenuItem, { filterMenuItemsByParent } from "./menuItem";

interface Props {
	menu: MenuData,
	menuEmail: MenuData,
	menuPhone: MenuData,
	menuSocial: MenuData,
	pathname: string,
}

function Footer({menu, menuSocial, menuEmail, menuPhone, pathname, ...otherProps}: Props) {

	function scrollToTop(e: React.MouseEvent) {
		e.preventDefault();

		if (isBrowser()) {
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}

	const rootMenuItems = filterMenuItemsByParent(menu, null);
	const rootMenuContactEmail = filterMenuItemsByParent(menuEmail, null);
	const rootMenuContactPhone = filterMenuItemsByParent(menuPhone, null);
	const rootMenuSocialItems = filterMenuItemsByParent(menuSocial, null);

	return (<>
		<div id="footerWrapper" className="bg-primary-500 text-white text-center pt-16 pb-8 md:pt-16 md:pb-8 xl:pt-40 xl:pb-32 text-base">
			<footer className="max-w-screen-2xl mx-auto flex flex-col md:flex-row items-start md:items-center text-left px-8 md:px-20 xl:px-24 2xl:px-32 gap-x-24">
				<div className="mb-16 md:mb-0">
					<div className="logoVertical"/>
				</div>

				<div className="mb-16 md:mb-0 grow">
					<div className="text-3xl leading-normal mb-16 md:mb-0">
						<ul className="menuFooterContact my-0 text-secondary-300">
							{rootMenuContactEmail && rootMenuContactEmail.map((item, index) => {
								return <MenuItem
									menu={menu}
									item={item}
									key={'item' + index}
									pathname={pathname}
									index={index}
									siblingsCount={rootMenuContactEmail.length - 1}
									separator={"/"}
									classNameAnchor="text-secondary-300"
								/>
							})}
						</ul>

						<ul className="menuFooterContact my-0">
							{rootMenuContactPhone && rootMenuContactPhone.map((item, index) => {
								return <MenuItem
									menu={menu}
									item={item}
									key={'item' + index}
									pathname={pathname}
									index={index}
									siblingsCount={rootMenuContactPhone.length - 1}
									separator={"/"}
								/>
							})}
						</ul>

						<ul className="menuFooterContact my-0">
							{rootMenuSocialItems && rootMenuSocialItems.map((item, index) => {
								return <MenuItem
									menu={menu}
									item={item}
									key={'item' + index}
									pathname={pathname}
									index={index}
									siblingsCount={rootMenuSocialItems.length - 1}
									separator={"/"}
								/>
							})}
						</ul>
					</div>

					<div className="flex flex-col lg:flex-row justify-between md:items-end gap-x-24">
						<ul className="menuFooter md:text-sm my-0">
							{rootMenuItems && rootMenuItems.map((item, index) => {
								return <MenuItem
									menu={menu}
									item={item}
									key={'item' + index}
									pathname={pathname}
									index={index}
									siblingsCount={rootMenuItems.length - 1}
								/>;
							})}
						</ul>

						<div className="text-xs text-left md:text-right mb-4">
							<img src="/images/rics_white.svg" width="130" height="46" alt="Rics" className="inline-block mb-4 mt-8 md:mt-0"/><br/>
							Copyright &copy; {new Date().getFullYear()} - Niek Co Limited / Site by Hallo Digital
						</div>
					</div>
				</div>
			</footer>
		</div>
	</>
);
}

export default Footer;
